// Imports
import GhostContentAPI from '@tryghost/content-api';


// Initialize Ghost API
const ghostAPIKey = 'bd2f5f7cd0a5ddb4423ca55589';

const ghost = new GhostContentAPI({
	url: 'https://hoa-express-blog.ghost.io',
	key: ghostAPIKey,
	version: 'v6.0',
});


// Export
export default ghost;
